import React from 'react';
import { Link } from 'react-router-dom';
import './ForumHomePage.css';

const ForumHomePage = () => {
  return (
    <div className="forum-homepage page-container">
      <h2 className="toc-title"> Community Discussions</h2>
      <div className="micro-void"></div>
      <hr />

      <p className="forum-intro">
      We are building this platform to empower people to live healthier, balanced, more meaningful lives. Your feedback will help us refine and improve this journey, ensuring we can make your experience better and deliver meaningful results.</p>

      <div className="forum-category">
        <h2 className="category-title2">Feedback</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Feedback" className="forum-link">General Feedback</Link></li>
          <li><Link to="/forum/User_Experience" className="forum-link">User Experience (UX)</Link></li>
          <li><Link to="/forum/Developer" className="forum-link">Developer Issues & Ideas</Link></li>
          <li><Link to="/forum/Suggestion_Box" className="forum-link">Suggestion Box</Link></li>
        </ul>
      </div>

      <hr />

      <div className="forum-category">
        <h2 className="category-title2">Spiritual</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Spiritual" className="forum-link">General Spiritual Discussion</Link></li>
          <li><Link to="/forum/Meditation" className="forum-link">Meditation</Link></li>
          <li><Link to="/forum/Nature" className="forum-link">Nature</Link></li>
          <li><Link to="/forum/Gratitude" className="forum-link">Gratitude</Link></li>
        </ul>
      </div>
      
      <div className="forum-category">
        <h2 className="category-title2">Physical</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Physical" className="forum-link">General Physical Discussion</Link></li>
          <li><Link to="/forum/Exercise" className="forum-link">Exercise</Link></li>
          <li><Link to="/forum/Cardio" className="forum-link">Cardio</Link></li>
          <li><Link to="/forum/Strength" className="forum-link">Strength</Link></li>
          <li><Link to="/forum/Flexibility" className="forum-link">Flexibility</Link></li>
          <li><Link to="/forum/Nutrition" className="forum-link">Nutrition</Link></li>
          <li><Link to="/forum/Hydration" className="forum-link">Hydration</Link></li>
          <li><Link to="/forum/Intermittent_Fasting" className="forum-link">Intermittent Fasting</Link></li>
          <li><Link to="/forum/Balanced_Diet" className="forum-link">Balanced Diet</Link></li>
          <li><Link to="/forum/Sleep" className="forum-link">Sleep</Link></li>
        </ul>
      </div>
      
      <div className="forum-category">
        <h2 className="category-title2">Intellectual</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Intellectual" className="forum-link">General Intellectual Discussion</Link></li>
          <li><Link to="/forum/Lifelong_Learning" className="forum-link">Lifelong Learning</Link></li>
          <li><Link to="/forum/Reading" className="forum-link">Reading</Link></li>
          <li><Link to="/forum/Languages" className="forum-link">Learning Languages</Link></li>
          <li><Link to="/forum/Brain_Games" className="forum-link">Brain Games</Link></li>
        </ul>
      </div>
      
      <div className="forum-category">
        <h2 className="category-title2">Relational</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Relational" className="forum-link">General Relational Discussion</Link></li>
          <li><Link to="/forum/Relationships" className="forum-link">Relationships</Link></li>
          <li><Link to="/forum/Communication" className="forum-link">Communication</Link></li>
          <li><Link to="/forum/Active_Listening" className="forum-link">Active Listening</Link></li>
          <li><Link to="/forum/Speaking" className="forum-link">Speaking</Link></li>
          <li><Link to="/forum/Conflict_Resolution" className="forum-link">Conflict Resolution</Link></li>
        </ul>
      </div>
      
      <div className="forum-category">
        <h2 className="category-title2">Emotional</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Emotional" className="forum-link">General Emotional Discussion</Link></li>
          <li><Link to="/forum/Stress_Management" className="forum-link">Stress Management</Link></li>
          <li><Link to="/forum/Emotional_Resilience" className="forum-link">Emotional Resilience</Link></li>
          <li><Link to="/forum/Emotional_Intelligence" className="forum-link">Emotional Intelligence</Link></li>
        </ul>
      </div>

      <div className="forum-category">
        <h2 className="category-title2">Habits</h2>
        <ul className="forum-list">
          <li><Link to="/forum/Habits" className="forum-link">Habits: The Basics</Link></li>
        </ul>
      </div>
      <hr />
    </div>
  );
  
};

export default ForumHomePage;
